module.exports = __webpack_public_path__ + "assets/6b9b462c232c538f46844131788a3d46.svg";